import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../context/authcontext";

interface TenantRole {
  role_key: string;
  role_name: string;
}

export function useTenantRole(selectedTenantId: number | string) {
  const { auth } = useContext(AuthContext);

  const determineRole = (contextAuth: any, tenantId: number | string) => {
    // Try localStorage first (primary source)
    const authStr = localStorage.getItem("authResponse");
    let authData = null;

    if (authStr) {
      try {
        authData = JSON.parse(authStr);
      } catch {
        // If localStorage parse fails, fall back to context
        authData = contextAuth;
      }
    } else {
      // If localStorage is empty, use context
      authData = contextAuth;
    }

    if (!authData) return null;

    // Check if user is Super Admin
    const isSuperAdmin =
      authData.tenants?.some(
        (t: any) =>
          t.role_key?.toLowerCase() === "superadmin" ||
          t.role_key?.toLowerCase() === "super_admin" ||
          t.role_name?.toLowerCase() === "superadmin" ||
          t.role_name?.toLowerCase() === "super_admin" ||
          t.role_key?.toLowerCase() === "platform_analyst" ||
          t.role_name?.toLowerCase() === "platformanalyst" ||
          t.role_key?.toLowerCase() === "apiadmin" ||
          t.role_key?.toLowerCase() === "api_admin" ||
          t.role_name?.toLowerCase() === "apiadmin" ||
          t.role_name?.toLowerCase() === "api_admin"
      ) || false;

    let tenant = null;

    if (tenantId && tenantId !== "") {
      // If a specific tenant is selected, find that tenant
      tenant = authData.tenants?.find(
        (t: any) => String(t.tenant_id) === String(tenantId)
      );
    } else if (isSuperAdmin) {
      // For Super Admin with no tenant selected, use the first Super Admin tenant
      tenant = authData.tenants?.find(
        (t: any) =>
          t.role_key?.toLowerCase() === "superadmin" ||
          t.role_key?.toLowerCase() === "super_admin" ||
          t.role_name?.toLowerCase() === "superadmin" ||
          t.role_name?.toLowerCase() === "super_admin" ||
          t.role_key?.toLowerCase() === "platform_analyst" ||
          t.role_name?.toLowerCase() === "platformanalyst" ||
          t.role_key?.toLowerCase() === "apiadmin" ||
          t.role_key?.toLowerCase() === "api_admin" ||
          t.role_name?.toLowerCase() === "apiadmin" ||
          t.role_name?.toLowerCase() === "api_admin"
      );
    }

    return tenant ? { role_key: tenant.role_key, role_name: tenant.role_name } : null;
  };

  const [role, setRole] = useState<TenantRole | null>(() => determineRole(auth, selectedTenantId));

  useEffect(() => {
    setRole(determineRole(auth, selectedTenantId));
  }, [selectedTenantId, auth]);

  return role;
}

const TenantRoleDisplay = ({
  selectedTenantId,
}: {
  selectedTenantId: number | string;
}) => {
  const role = useTenantRole(selectedTenantId);

  if (!role) return <span>No role found for this tenant.</span>;

  return (
    <div>
      <strong>Role Key:</strong> {role.role_key} <br />
      <strong>Role Name:</strong> {role.role_name}
    </div>
  );
};

export default TenantRoleDisplay;
